import { call, takeEvery, takeLatest } from 'redux-saga/effects';
// redux
import * as Actions from './actions';
import * as E from './workers';

export function* watchGetCredentials() {
  yield call(E.ensureGetCredentials, { type: Actions.getCredentials.TRIGGER });
  yield takeLatest(Actions.getCredentials.TRIGGER, E.ensureGetCredentials);
}

export function* watchPatchNetSuiteCredentials() {
  yield takeEvery(
    Actions.patchCredentials.TRIGGER,
    E.ensurePatchNetSuiteCredentials
  );
}
